let signatureForm = [
  'XAdES',
  'CAdES',
  'PAdES',
  'CodesSigning JAR',
  'CodesSigning PGP',
  'CodesSigning Microsoft Authenticode',
  'DOSSZIE'
]

export default signatureForm
